import { t } from 'i18next';
import React, { useState } from 'react';
import moment from 'moment';
import { CommonFlex, CommonText, CommonGrid } from 'styledComponents/common';

import AudioPlayer from '../TaskApproval/AudioPlayer';
import EvidencesModal from './EvidencesModal';
import { EvidenceCard, EvidenceThumbnail } from './taskDetailsStyles';

const TaskEvidence = ({ title = 'evidence', evidences, noTitle = false }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState(false);

  const popupToggle = index => {
    setPopupOpen(!popupOpen);
    setSelectedEvidence(index);
  };
  return (
    <>
      <EvidencesModal
        isOpen={popupOpen}
        toggle={popupToggle}
        evidences={evidences?.filter(evidence => evidence.image)}
        selectedEvidence={selectedEvidence}
      />
      <CommonFlex gap="16px" direction="column" alignItems="start">
        {!noTitle && (
          <CommonText name title fontSize="16px">
            {t(title)}
          </CommonText>
        )}
        <CommonFlex gap="15px" wrap="wrap" alignItems="stretch">
          {evidences
            ?.filter(evidence => evidence.image || evidence.audio)
            ?.map((evidence, index) => (
              <EvidenceCard key={index}>
                <CommonText name title fontSize="12px">
                  {moment(evidence?.created_at).format('hh:mm a, DD MMM YYYY')}
                </CommonText>
                <EvidenceThumbnail
                  key={index}
                  onClick={() => popupToggle(index)}
                >
                  <img
                    src={evidence.image}
                    alt=""
                    width="100%"
                  />
                </EvidenceThumbnail>
                {evidence.audio && (
                  <AudioPlayer key={index} audio={evidence.audio} />
                )}
                {evidence.message && (
                  <CommonText name fontSize="13px">
                    Note: {evidence.message}
                  </CommonText>
                )}
              </EvidenceCard>
            ))}
        </CommonFlex>
      </CommonFlex>
    </>
  );
};

export default TaskEvidence;
